/* <pdp-faq single>: when one <details> opens, close the others; animates the answer height (200ms, like Finsweet). */
if (!customElements.get('pdp-faq')) {
  class PdpFaq extends HTMLElement {
    connectedCallback() {
      this.ac = new AbortController();
      this.reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
      this.querySelectorAll('summary').forEach((sum) => {
        sum.addEventListener('click', (e) => this.onClick(e, sum.parentElement), { signal: this.ac.signal });
      });
    }
    disconnectedCallback() { this.ac.abort(); }
    onClick(e, item) {
      e.preventDefault();
      if (item.open) { this.close(item); } else {
        if (this.hasAttribute('single')) this.querySelectorAll('details[open]').forEach((o) => { if (o !== item) this.close(o); });
        this.open(item);
      }
    }
    body(item) { return item.querySelector('.pd-acc__body'); }
    open(item) {
      const b = this.body(item);
      item.open = true;
      if (this.reduce || !b) return;
      b.style.overflow = 'hidden'; b.style.maxHeight = '0px'; b.style.transition = 'max-height .2s';
      requestAnimationFrame(() => { b.style.maxHeight = b.scrollHeight + 'px'; });
      b.addEventListener('transitionend', () => { b.style.maxHeight = ''; b.style.overflow = ''; b.style.transition = ''; }, { once: true });
    }
    close(item) {
      const b = this.body(item);
      if (this.reduce || !b) { item.open = false; return; }
      b.style.overflow = 'hidden'; b.style.maxHeight = b.scrollHeight + 'px'; b.style.transition = 'max-height .2s';
      requestAnimationFrame(() => { b.style.maxHeight = '0px'; });
      b.addEventListener('transitionend', () => { item.open = false; b.style.maxHeight = ''; b.style.overflow = ''; b.style.transition = ''; }, { once: true });
    }
  }
  customElements.define('pdp-faq', PdpFaq);
}
